import React from "react";
import { Navigation, Link } from "react-router";
import {sidebarOnClicks, scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import FontAwesome from "react-fontawesome";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import Zoom from "js/utilities/zoom-handler"
import Amplitude from "js/utilities/amplitude";
import Api from "../../utilities/fnapi-client";

export default React.createClass({

  /*********************************************************************************************************************
   Screen configuration
   Not positive if all of this is necessary
   *********************************************************************************************************************/

  displayName: "account",
  contextTypes: {
    router: React.PropTypes.object.isRequired
  },
  scrollToGuide : null,
  scrollingEl: null,


  /*********************************************************************************************************************
   Render methods
   *********************************************************************************************************************/

  render: function() {
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section className="content-wrapper">
              {this.state.webPage &&
                <div className="content">
                  <div className="title">
                    <h2>{this.state.webPage.title}</h2>
                  </div>
                  <div className="content-body" dangerouslySetInnerHTML={{ __html: this.state.webPage.body }} />
                </div>
              }
            </section>
            <SDKSidebar menuType="account" title="Account"/>
          </div>
        </div>
      </div>
    );
  },

  /*********************************************************************************************************************
   Built-in react methods
   *********************************************************************************************************************/

  getInitialState: function() {
    return {
      webPage: null
    }
  },

  componentDidMount: function() {
    mountCode(this);
    this.fetchPageContent();
  },

  urlChanged() {
    urlChangeHandler();
  },

  /*********************************************************************************************************************
   Account/Company level methods
   *********************************************************************************************************************/

  // Gets *all* of the account data from api.zoomauth
  fetchPageContent: function() {
    Api.get("web/dev/terms").then(( response ) => {
      this.setState({webPage: response.data});
      console.log(this.state);
    }).catch( (error) => {
      alert(error);
    });
  },

});



// WEBPACK FOOTER //
// ./src/js/components/screens/terms.jsx